(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
